export function getIntParam(searchParams, key, defaultValue) {
  const raw = searchParams.get(key);
  if (raw == null || raw === '') return defaultValue;
  const parsed = Number.parseInt(raw, 10);
  return Number.isFinite(parsed) ? parsed : defaultValue;
}

export function getStringParam(searchParams, key, defaultValue = '') {
  const raw = searchParams.get(key);
  return raw == null ? defaultValue : raw;
}

export function getBoolParam(searchParams, key, defaultValue = false) {
  const raw = searchParams.get(key);
  if (raw == null) return defaultValue;
  if (raw === '1' || raw === 'true') return true;
  if (raw === '0' || raw === 'false') return false;
  return defaultValue;
}

export function setIfTruthy(params, key, value) {
  if (value == null) return;
  const v = typeof value === 'string' ? value.trim() : value;
  if (v === '' || v === false) return;
  params.set(key, String(v));
}

export function setIfNotDefault(params, key, value, defaultValue) {
  if (value == null) return;
  if (String(value) === String(defaultValue)) return;
  params.set(key, String(value));
}
